import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { finishTutorial } from "../joyrideStepHelpers";
import TutorialSkipConfirmationContent from "../../components/TutorialSkipConfirmationContent";

interface SkipTutorialProps {
    continueTutorial: () => void;
}

const SkipTutorial: React.FC<SkipTutorialProps> = ({ continueTutorial }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { branchId } = useParams();

    return (
        <TutorialSkipConfirmationContent
            title={t("Want to learn on your own?")}
            description={t("Save time by taking a quick training course on warehouse workflows")}
            additionalDescription={
                <Trans
                    i18nKey="You can take the training later by clicking the button <strong>How to work with warehouses?</strong> in the menu."
                    components={{ strong: <strong /> }}
                />
            }
            onContinueTutorial={continueTutorial}
            onSkipTutorial={() => finishTutorial(branchId, navigate)}
        />
    );
};

export default SkipTutorial;
